<template>
  <footer class="footer">
    <div class="d-flex justify-content-between">
      <span class="copyright">&copy; 2021-2026 {{ legalName }}</span>

      <span class="float-right">
        <a href="#" @click.prevent="showInfo = true">Software</a>
      </span>
      <div class="float-right">
        <button class="theme-toggle" @click="toggleTheme" :title="isDark ? 'Switch to light mode' : 'Switch to dark mode'">
          <font-awesome-icon :icon="isDark ? 'sun' : 'moon'" />
        </button>
      </div>
    </div>
    <div v-if="showInfo" class="info-overlay" @click.self="showInfo = false">
      <div class="info-popup">
        <button class="close-btn" @click="showInfo = false">&times;</button>
        <h6>Software Info</h6>
        <hr>
        <p>&copy; 2021-2026 {{ legalName }}</p>
        <p>Version: Build {{ currentCompany.build }}</p>
        <hr>
        <p class="mb-1"><strong>Development</strong></p>
        <p class="mb-1">
          Thomas Bauche &mdash;
          <a href="mailto:thomas@bauche-hamburg.de">thomas@bauche-hamburg.de</a>
        </p>
        <p class="mb-0">
          Matthias Fricke &mdash;
          <a href="https://www.cleverhomelabs.com" target="_blank" rel="noopener">cleverhomelabs.com</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PageFooter',
  data: function () {
    return {
      showInfo: false,
      currentCompany: { logo: 'CHL_Logo.png', name: 'CHL', short: 'CHL', backendMode: false, build: '', ios: '', android: '' }
    }
  },
  computed: {
    ...mapGetters(['theme']),
    isDark () {
      return this.theme === 'dark'
    },
    legalName () {
      return this.currentCompany.legalName || 'Clever Home Labs GmbH'
    }
  },
  mounted () {
    this.loadCompanyValues()
  },
  methods: {
    loadCompanyValues () {
      this.$store.dispatch('getCompanyData')
        .then(() => {
          this.currentCompany = this.$store.getters.company
        })
        .catch(() => {
          /* eslint-disable no-console */
          console.log('could not get company data')
        })
    },
    toggleTheme () {
      this.$store.commit('setTheme', this.isDark ? 'light' : 'dark')
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  font-size: 13px;
  color: #666;
  line-height: 40px;
  border-top: 1px solid #ddd;
  margin-top: 50px;

  .list-inline-item {
    margin-right: 10px;
  }

  a {
    color: #666;
  }

  .theme-toggle {
    background: none;
    border: none;
    color: #666;
    font-size: 14px;
    cursor: pointer;
    padding: 0 8px 0 0;
    vertical-align: middle;
    line-height: 40px;

    &:hover {
      color: #333;
    }
  }
}

.info-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-popup {
  background: #fff;
  border-radius: 0.5rem;
  padding: 1.5rem 2rem;
  min-width: 280px;
  max-width: 420px;
  width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  position: relative;
  font-size: 14px;
  line-height: 1.6;
  color: #333;

  h6 {
    font-weight: 600;
    margin-bottom: 0;
  }

  a {
    color: #0069d9;
  }

  .close-btn {
    position: absolute;
    top: 0.6rem;
    right: 0.8rem;
    background: none;
    border: none;
    font-size: 1.4rem;
    line-height: 1;
    color: #888;
    cursor: pointer;
    padding: 0;

    &:hover {
      color: #333;
    }
  }
}
</style>
